import React, { useRef, useState } from 'react';
import './MagicGlass.css';

const SCALE = 2;

const MagicGlass = ({ children, width = 600, height = 400 }) => {
  const containerRef = useRef(null);
  const [mousePos, setMousePos] = useState({ x: 0, y: 0 });
  const [visible, setVisible] = useState(false);

  const lensSize = 100;

  const handleMouseMove = (e) => {
    const rect = containerRef.current.getBoundingClientRect();
    const x = e.clientX - rect.left;
    const y = e.clientY - rect.top;
    setMousePos({ x, y });
  };

  return (
    <div
      className="magic-glass-container"
      ref={containerRef}
      onMouseEnter={() => setVisible(true)}
      onMouseLeave={() => setVisible(false)}
      onMouseMove={handleMouseMove}
      style={{ width, height }}
    >
      {/* Main Drawing */}
      <div className="drawing-content">
        {children}
      </div>

      {visible && (
        <div
          className="lens"
          style={{
            width: lensSize,
            height: lensSize,
            left: mousePos.x - lensSize / 2,
            top: mousePos.y - lensSize / 2,
          }}
        >
          <div
            className="lens-zoom"
            style={{
              width: width * SCALE,
              height: height * SCALE,
              transform: `scale(${SCALE}) translate(-${mousePos.x - lensSize / (2 * SCALE)}px, -${mousePos.y - lensSize / (2 * SCALE)}px)`,
transformOrigin: `top left`,

            }}
          >
            {children}
          </div>
        </div>
      )}
    </div>
  );
};

export default MagicGlass;
